/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Adm_Scope_Space_NamedInputs */

const en_adm_scope_space_named = /** @type {(inputs: Adm_Scope_Space_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Space ${i?.name}`)
};

const de_adm_scope_space_named = /** @type {(inputs: Adm_Scope_Space_NamedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bereich ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Space {name}" |
*
* @param {Adm_Scope_Space_NamedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_scope_space_named = /** @type {((inputs: Adm_Scope_Space_NamedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Scope_Space_NamedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_scope_space_named(inputs)
	return en_adm_scope_space_named(inputs)
});